module.exports = __webpack_public_path__ + "img/tennis.8b131f0d.svg";